import { render, staticRenderFns } from "./FormPartnershipType.vue?vue&type=template&id=6d56c61a&scoped=true&"
import script from "./FormPartnershipType.vue?vue&type=script&lang=js&"
export * from "./FormPartnershipType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56c61a",
  null
  
)

export default component.exports